<template>
  <div class="CalcCheckersProcents">
    <v-row>
      <v-col class="col-xs-12 col-md-12 col-lg-6">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="gi"
              label="Гарантия исполнения контракта"
              placeholder="Гарантия исполнения контракта"
              hide-details
              type="number"
              step="0.01"
            />
            <v-text-field
              v-model="gu"
              label="Гарантия на участие (тендерная)"
              placeholder="Гарантия на участие (тендерная)"
              hide-details
              type="number"
              step="0.01"
            />
            <v-text-field
              v-model="gv"
              label="Гарантия возврата аванса"
              placeholder="Гарантия возврата аванса"
              hide-details
              type="number"
              step="0.01"
            />
            <v-text-field
              v-model="gk"
              label="Гарантия качества (гарантийные обязательства)"
              placeholder="Гарантия качества (гарантийные обязательства)"
              hide-details
              type="number"
              step="0.01"
            />
          </v-col>
          <v-col
            cols="3"
            style="display: inline-flex; flex-direction: column-reverse"
          >
            <v-btn class="mt-2 success" @click="save" :disabled="load">
              <v-icon left>save</v-icon>
              Сохранить
            </v-btn>
            <v-spacer />
            <v-btn class="mt-2 warning" @click="generate" :disabled="load">
              <v-icon left>create</v-icon>
              Собрать данные
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "CalcCheckersProcents",
  components: {},
  data: () => ({
    gi: "",
    gu: "",
    gv: "",
    gk: "",
    load: false,
  }),
  methods: {
    async init() {
      try {
        this.load = true;
        const { data } = await this.$store.dispatch("getCalcSettingsProcent");
        this.gi = data.gi;
        this.gu = data.gu;
        this.gv = data.gv;
        this.gk = data.gk;
      } finally {
        this.load = false;
      }
    },
    async save() {
      try {
        this.load = true;
        await this.$store.dispatch("setCalcSettingsProcent", {
          gi: this.gi,
          gu: this.gu,
          gv: this.gv,
          gk: this.gk,
        });
      } finally {
        this.load = false;
      }
    },
    generate() {},
  },
  mounted() {
    this.init();
  },
};
</script>
<style lang="sass" scoped>
.CalcCheckersProcents
  padding: 0 0 20px 0
</style>
